import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup } from "@angular/forms";

@Component({
    selector: 'app-modal-bcra',
    templateUrl: './modal-bcra.component.html',
    styleUrls: ['./modal-bcra.component.scss'],
    standalone: false
})
export class ModalBcraComponent implements OnInit {
  periodoini: any = "";
  periodofin: any = "";
  comentarios: any = "";
  situacionSeleccionada: any = "";
  form: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ModalBcraComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      camposUpdate: this.fb.array([]),
    });
  }

  get arrayUpdatesControl() {
    return this.form.get('camposUpdate') as FormArray;
  }

  getInputType(index: number): string {
    const selectedFieldName = this.arrayUpdatesControl.at(index).value.fieldToChange;
    if (!selectedFieldName) {
      return 'text';
    }

    const fieldDefinition = this.data.availableFields.find(f => f.name === selectedFieldName);
    return fieldDefinition ? fieldDefinition.inputType : 'text';
  }

  agregarCampoVacio(): void {
    if (this.arrayUpdatesControl.length < 5) {
      this.arrayUpdatesControl.push(this.fb.group({
        fieldToChange: [''],
        newValue: [''],
      }));
    }
  }

  eliminarCampo(index: number): void {
    this.arrayUpdatesControl.removeAt(index);
  }

  isAnythingSelected(): boolean {
    const hasPeriods = this.periodoini && this.periodofin;
    const hasSituation = this.situacionSeleccionada !== "";
    const detailedEdits = this.arrayUpdatesControl.value.some(c => c.fieldToChange && c.newValue);

    return hasPeriods || hasSituation || detailedEdits;
  }

  onNoClick(): void {
    this.dialogRef.close({ status: false });
  }

  getSelectOptions(index: number): any[] {
    const selectedFieldName = this.arrayUpdatesControl.at(index).value.fieldToChange;
    if (!selectedFieldName) {
      return [];
    }

    const fieldDefinition = this.data.availableFields.find(f => f.name === selectedFieldName);
    return fieldDefinition && fieldDefinition.options ? fieldDefinition.options : [];
  }

  onSubmit(): void {
    // Validaciones de períodos
    if (this.periodoini && this.periodofin) {
      if (this.periodoini >= this.periodofin) {
        // En un escenario real, mostrarías un error aquí
        return;
      }
      if (this.periodoini.length < 6 || this.periodofin.length < 6) {
        return;
      }
    }

    const detailedEdits = this.arrayUpdatesControl.controls
      .filter(control => control.value.fieldToChange && control.value.newValue)
      .reduce((acc, control) => {
        const fieldName = control.value.fieldToChange;
        let fieldValue = control.value.newValue;
        const fieldDef = this.data.availableFields.find(f => f.name === fieldName);

        if (fieldDef && fieldDef.inputType === 'date' && fieldValue) {
          const date = new Date(fieldValue);
          fieldValue = date.toISOString().slice(0, 10).replace(/-/g, "");
        }

        acc[fieldName] = fieldValue;
        return acc;
      }, {});

    const res = {
      status: true,
      value: this.situacionSeleccionada,
      estado: "NOC",
      periodoini: this.periodoini,
      periodofin: this.periodofin,
      comentarios: this.comentarios,
      detailedEdits: detailedEdits
    };

    this.dialogRef.close(res);
  }

  getAvailableFields(index: number): any[] {
    const selectedFields = this.arrayUpdatesControl.value.map(item => item.fieldToChange);
    const currentFieldValue = this.arrayUpdatesControl.at(index).value.fieldToChange;

    return this.data.availableFields.filter(field => {
      return !selectedFields.includes(field.name) || field.name === currentFieldValue;
    });
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}

